// ── Hole Indicator / Usable Hole Indicator text ───────────────────────────────────────────
// Label + tooltip copy for the two circles flanking each seat's info box (rendered by
// Player.js, styled as .hole-indicator in gameroom.css). React-free so it unit-tests on its
// own, like replayBoard.js.
//
// The two numbers behind them ship per seat on every game payload:
//   numHoleCards           how many hole cards the seat holds
//   minHoleUsed/maxHoleUsed  how many of them its best five must use
// The floor is derived server-side from the hole count (two cards or fewer -> 0, more than
// two -> 2); the ceiling defaults to 2, moves only by Pup effect, and is INDEPENDENT of the
// count — so it may legally sit ABOVE the number of cards held (a player can raise it in
// preparation for drawing more). Both move mid-round, which is the whole reason the table
// gets to see them.

// The usable face ALWAYS prints both bounds — "2-2", never "2". A fixed two-number shape keeps
// the 32px circle from re-fitting its type as the round goes on, and a lone number would read
// as a card COUNT, which is exactly what the other circle shows one nameplate away. The prose
// lives in the tooltip.
export const usableRangeLabel = (min, max) => `${min}-${max}`;

// "You have 2 Hole Cards" / "This player has 1 Hole Card".
export const holeCountTip = (n, isHero = false) =>
  `${isHero ? 'You have' : 'This player has'} ${n} Hole Card${n === 1 ? '' : 's'}`;

// First matching rule wins:
//   1. no floor AND a ceiling at or above everything they hold -> unconstrained
//   2. a real range                                            -> "X to Y"
//   3. a fixed count                                           -> "X"
// Rule 1 is why the hole count is a parameter: with 2 cards held, a ceiling of 2 and a ceiling
// of 3 are the same freedom, and claiming a range there would be a lie.
export const usableRangeTip = (min, max, n, isHero = false) => {
  const who = isHero ? 'You' : 'This player';
  if (min === 0 && max >= n) {
    return `${who} can use any number of ${isHero ? 'your' : 'their'} Hole Cards`;
  }
  if (min !== max) return `${who} must use ${min} to ${max} Hole Cards`;
  return `${who} must use ${min} Hole Card${min === 1 ? '' : 's'}`;
};
